import React, { Component } from "react";

import UBXFormSelect from "./../ubx/form/select";
import UBXSlider from "./../common/slider";

import { getStaticText } from "./../../helpers/system";
import { properNumber } from "./../../helpers/number";

import ProductText from "./../../const/product.json";

const AMOUNT_DIVISOR = 1000;

export default class ProductConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isBusy: false,
            isReady: false,
            isRedirect: false,
            optionsReady: false,
            termOptions: [],
            loanAmount: "",
            loanTerm: "",
        };
    }

    componentDidMount() {
        this.initialize();
    }

    initialize() {
        const { data = {}, minAmount = 0 } = this.props;

        const initState = { ...data };
        if (!initState["loanAmount"]) {
            initState["loanAmount"] = minAmount;
        }

        this.setState(initState);
    }

    handleChange(value) {
        const { onChangeAmount = false } = this.props;

        const loanAmount = value * AMOUNT_DIVISOR;

        this.setState({ loanAmount });

        if (onChangeAmount) {
            onChangeAmount(loanAmount);
        }
    }

    handleChangeTerm(name, value) {
        const { onChangeTerm = false } = this.props;

        if (onChangeTerm) {
            onChangeTerm(value);
        }
    }

    handleCustomAmount(e) {
        e.preventDefault();

        const { value } = e.target;

        const { onChangeAmount = false, maxAmount = 1000 } = this.props;

        const loanAmount = parseInt(value.replace("₱ ", "").replace(/,/gm, "")) || 0;

        if (loanAmount <= maxAmount) {
            this.setState({ loanAmount });

            if (onChangeAmount) {
                onChangeAmount(loanAmount);
            }
        }
    }

    checkLoanAmount(e) {
        e.preventDefault();

        const { onChangeAmount = false, minAmount = 1000 } = this.props;

        let loanAmount = parseInt(e.target.value.replace("₱ ", "").replace(/,/gm, ""));

        if (loanAmount <= minAmount) {
            loanAmount = minAmount;
        }

        this.setState({ loanAmount });

        if (onChangeAmount) {
            onChangeAmount(loanAmount);
        }
    }

    render() {
        const {
            productOrg,
            minAmount = 1000,
            maxAmount = 1000,
            dark = false,
            loanTermValue,
            loanAmountValue: defaultLoanAmount,
            termOptions = [],
            loanType,
        } = this.props;
        const { loanAmount } = this.state;

        let customClass;
        if (loanType) {
            customClass = loanType.replace(/_/g, "-");
        }

        let darkClassName = dark ? "dark" : "";
        let displayAmount = "₱ 0";

        if (defaultLoanAmount) {
            displayAmount = "₱ " + properNumber(defaultLoanAmount);
        }

        if (loanAmount) {
            displayAmount = "₱ " + properNumber(loanAmount);
        }

        let multipleOfTen = ((maxAmount - minAmount) / AMOUNT_DIVISOR) % 10 === 0 ? 10 : 1;
        let multipleOfFive = ((maxAmount - minAmount) / AMOUNT_DIVISOR) % 5 === 0 ? 5 : 1;

        const loanAmountCaption = getStaticText(ProductText, ["configLoanAmountCaption", productOrg], {
            "min-amount": properNumber(minAmount),
            "max-amount": properNumber(maxAmount),
        });

        return (
            <section id="product-config">
                <div id="amount-input" className={`ubx-form text-input ${darkClassName}`}>
                    <div className="d-flex justify-content-between">
                        <label htmlFor="loan-amount">{getStaticText(ProductText, "configLoanAmountLabel")}</label>
                    </div>
                    <span className="field">
                        <input
                            type="mumber"
                            name="loan-amount"
                            value={displayAmount}
                            onChange={(e) => this.handleCustomAmount(e)}
                            onBlur={(e) => this.checkLoanAmount(e)}
                        />
                    </span>
                </div>
                <UBXSlider
                    id="product-loan-amount-slider"
                    step={multipleOfTen ? multipleOfTen : multipleOfFive}
                    min={minAmount / AMOUNT_DIVISOR}
                    max={maxAmount / AMOUNT_DIVISOR}
                    value={defaultLoanAmount ? defaultLoanAmount / AMOUNT_DIVISOR : loanAmount / AMOUNT_DIVISOR}
                    onChange={(value) => this.handleChange(value)}
                    loanType={loanType}
                />
                <div className={`range-caption ${darkClassName}`}>{loanAmountCaption}</div>
                <br />
                <UBXFormSelect
                    id="product-loan-term"
                    onChange={(name, value) => this.handleChangeTerm(name, value)}
                    label={getStaticText(ProductText, ["configLoanTermLabel", productOrg])}
                    type="pill"
                    pillColor={dark ? "dark" : "primary"}
                    name="loan-term"
                    required={true}
                    value={parseInt(loanTermValue) || ""}
                    options={termOptions.map((value) => {
                        return { value, name: `${value} ${value === 1 ? "Month" : "Months"}` };
                    })}
                    className={customClass}
                    searchable={false}
                />
            </section>
        );
    }
}
